import type { SurveyQuestion } from './survey-question.types'

/** Figma 5074-13376 — short text placeholder when definition omits one. */
export const SURVEY_SHORT_TEXT_DEFAULT_PLACEHOLDER = 'Type your answer here....'

/** Figma 5074-13418 — long text placeholder when definition omits one. */
export const SURVEY_LONG_TEXT_DEFAULT_PLACEHOLDER =
  'Share your thoughts here-There are no right or wrong answers'

export function shortTextPlaceholder(question: SurveyQuestion): string {
  return question.placeholder?.trim() || SURVEY_SHORT_TEXT_DEFAULT_PLACEHOLDER
}

export function longTextPlaceholder(question: SurveyQuestion): string {
  return question.placeholder?.trim() || SURVEY_LONG_TEXT_DEFAULT_PLACEHOLDER
}

export function textAnswerCharCount(value: string | null): number {
  return value?.length ?? 0
}

/** Word count for long-text footer (Figma 5074-13416). */
export function textAnswerWordCount(value: string | null): number {
  const trimmed = value?.trim() ?? ''
  if (trimmed === '') return 0
  return trimmed.split(/\s+/).filter((part) => part.length > 0).length
}

export function formatWordCountLabel(wordCount: number): string {
  return wordCount === 1 ? '1 Word' : `${wordCount} Words`
}

export function isOpenTextAnswerEmpty(question: SurveyQuestion, draft: string | null): boolean {
  if (draft == null || draft.trim() === '') return true
  if (
    (question.type === 'short_text' ||
      question.type === 'long_text' ||
      question.type === 'video') &&
    question.minLength != null &&
    draft.trim().length < question.minLength
  ) {
    return true
  }
  return false
}
